export default [
  {
    title: "Account",
    icon: "UsersIcon",
    tagVariant: "light-warning",
    children: [
      {
        title: "Portal",
        icon: "MenuIcon",
        resource: "Account",
        action: "View",
        children: [
          {
            title: "Users",
            route: "Users-index",
            resource: "Account",
            action: "View",
          },
          {
            title: "Roles",
            route: "Roles-index",
            resource: "Role",
            action: "View",
          },
          {
            title: "Privilege",
            route: "Privilage-View",
            resource: "Previlage",
            action: "View",
          },
        ],
      },
      {
        title: "Client",
        icon: "MenuIcon",
        resource: "ClientAccount",
        action: "GetAll",
        children: [
          {
            title: "Users",
            route: "ClientAccount-GetAll",
            resource: "ClientAccount",
            action: "GetAll",
          },

          {
            title: "Roles",
            route: "ClientRole-GetAll",
            resource: "ClientRole",
            action: "GetAll",
          },
          {
            title: "Privilege",
            route: "ClientPrivileges-GetAll",
            resource: "ClientPrivileges",
            action: "GetAll",
          },
        ],
      },
    ]

  },
];
